import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { ChooseTemplateModalFacade } from '@api-ui-app/src/app/choose-template-modal/choose-template-modal.facade';
import { ECommerceProductTemplatesFacade } from '@api-ui-app/src/app/e-commerce-product-templates/e-commerce-product-templates.facade';
import { ItemToStore } from '@api-ui-app/src/app/choose-template-modal/types/item-to-store';
import { EProductTemplatesSearchParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-params';
import { DialogRef } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-ref';
import { skipWhile, take } from 'rxjs/operators';

@Component({
  selector: 'gd-choose-template-modal-container',
  templateUrl: './choose-template-modal-container.component.html',
  styleUrls: ['./choose-template-modal-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseTemplateModalContainerComponent implements OnInit {
  items$ = this.eCommerceProductTemplatesFacade.items$;
  searchParams$ = this.eCommerceProductTemplatesFacade.searchParams$;
  isProcessing$ = this.eCommerceProductTemplatesFacade.isProcessing$;
  isLoading$ = this.facade.isLoading$;
  constructor(
    private readonly facade: ChooseTemplateModalFacade,
    private readonly eCommerceProductTemplatesFacade: ECommerceProductTemplatesFacade,
    @Inject(DialogRef) private dialogReg: DialogRef<boolean>,
  ) {}

  ngOnInit() {
    this.eCommerceProductTemplatesFacade.load();
  }

  createTemplate() {
    this.eCommerceProductTemplatesFacade.createNewTemplate();
    this.closeModalAfterProcessing();
  }

  scrollDown() {
    this.eCommerceProductTemplatesFacade.loadMore();
  }

  addTemplateToStore(item: ItemToStore) {
    this.facade.addTemplateToStore(item);

    this.closeModalAfterProcessing();
  }

  changeSearchParams(params: EProductTemplatesSearchParams) {
    this.facade.changeSearchParams(params);
  }

  private closeModalAfterProcessing() {
    this.isProcessing$
      .pipe(
        skipWhile(isProcessing => !!isProcessing),
        take(1),
      )
      .subscribe(() => {
        this.dialogReg.close();
      });
  }
}
